import React, { FC, ReactElement } from 'react';
import './index.scss';

interface IProps {
  text?: string;
  children?: ReactElement;
  style?: Object;
}

const NoData: FC<IProps> = ({ text = '暂无合适的职位', children, style = {} }) => {
  return (
    <div
      className="no_data"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...style,
      }}
    >
      <img src={require('@imgs/no_data.png')} alt="" />
      <p>{text}</p>
      {children}
    </div>
  );
};

export default NoData;
